<template>
  <generic-view
    :title="$t('documents')"
    icon="folder open"
    v-bind:show_plus="true"
    v-on:add="add"
    v-on:filter="filter"
    :show_refresh="true"
    :header_buttons="header_buttons"
    @refresh="getData"
  >
    <div class="ui two horizontal link cards">
      <div
        class="card"
        v-for="(item, index) in documents"
        v-bind:key="index"
        v-on:click="view(item, index)"
      >
        <!-- <div class="ui circular image">
          <img src="/images/icons/matthew.png" />
        </div>-->
        <div class="content">
          <div class="right floated buttons">
            <div
              class="ui mini basic right floated icon button"
              v-on:click.stop="remove(item, index)"
              :data-tooltip="$t('delete document')"
            >
              <i class="red trash icon"></i>
            </div>
            <div
              class="ui mini basic right floated icon button"
              v-on:click.stop="download(item, index)"
              :data-tooltip="$t('download all files as zip')"
            >
              <i class="blue download icon"></i>
            </div>
          </div>
          <div class="header">{{ item.std_document_type.name }}</div>
          <div class="meta">
            <a>{{
              item.create_date | formatDate(enterprise_setup.simple_date_format)
            }}</a>
          </div>
          <div class="description">
            <p>{{ item.description }}</p>
            <h4 class="ui dividing header">{{ $t("files") }}</h4>
            <div class="ui divided selection list">
              <div
                class="item"
                v-on:click.stop="download_file(file, item)"
                v-for="(file, idx) in item.files"
                :key="idx"
              >
                <div
                  class="ui mini basic right floated mini icon button"
                  v-on:click.stop="remove_file(item, file, idx)"
                  :data-tooltip="$t('delete file')"
                >
                  <i class="red trash icon"></i>
                </div>
                <img
                  class="ui avatar image"
                  :src="
                    '/images/icons/file_types/' +
                      (file.fileType.includes('image')
                        ? 'image.png'
                        : file.fileType.includes('pdf')
                        ? 'pdf.jpeg'
                        : 'file.png')
                  "
                />
                <div class="content">
                  <div class="header">{{ file.filename }}</div>
                  <div class="description">
                    {{ $t("size") }} {{ file.fileSize | sizeFromKB }}.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-for="(mdl, index) in document_modals">
      <component
        :is="mdl"
        :key="index"
        :document_in="selected_document"
        :student_in="$props.student_in"
        v-on:succedded="succedded"
        v-on:destroy="destroy"
      ></component>
    </template>
  </generic-view>
</template>

<script>
import {
  local_api,
  error_toast,
  clone,
  api_host,
  enterprise_setup,
} from "@/utils";
import StudentDocumentModal from "./StudentDocumentModal";
import GenericView from "@/components/GenericContainer";
import filters from "@/filters";
import { stringify } from "../../utils";

export default {
  filters: filters,
  props: {
    module: Object,
    student_in: Object,
  },
  components: {
    "generic-view": GenericView,
  },
  data() {
    return {
      documents: [],
      all_documents: [],
      document_modals: [],
      selected_document: {},
      header_buttons: [],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    add() {
      this.document_modals.push(StudentDocumentModal);
    },
    remove_file(document, file, index) {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove file?"),
        function() {
          document.files.splice(index, 1);
          local_api(vm, "post", "/student_document/do-update-files", {
            i: document.uuid,
            f: JSON.stringify(document.files),
          })
            .then(() => {
              vm.$alertify.success(vm.$t("document updated"));
            })
            .catch((err) => {
              vm.$alertify.error(stringify(err));
            });
        },
      );
    },
    remove(document, index) {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove document?"),
        function() {
          local_api(vm, "post", "/student_document/do-remove", {
            u: document.uuid,
          })
            .then(() => {
              vm.documents.splice(index, 1);
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    destroy() {
      this.document_modals = [];
      this.selected_document = {};
    },
    succedded(document) {
      let trgtIdx = this.documents.findIndex((n) => n.uuid == document.uuid);
      if (trgtIdx != -1) this.documents.splice(trgtIdx, 1, document);
      else this.documents.push(document);
    },
    // eslint-disable-next-line no-unused-vars
    view(document, index) {
      this.selected_document = document;
      this.document_modals.push(StudentDocumentModal);
    },
    filter(query) {
      if (query == "") this.documents = this.all_documents;
      else
        this.documents = this.all_documents.filter(
          (p) =>
            p.setup &&
            (p.setup.name.toUpperCase().includes(query.toUpperCase()) ||
              p.setup.description.toUpperCase().includes(query.toUpperCase()) ||
              p.setup.files.find((f) =>
                f.filename.toUpperCase().includes(query.toUpperCase()),
              )),
        );
    },
    download_file(file, doc) {
      let vm = this;
      local_api(vm, "post", "/student_document/do-download-file", {
        i: file.file_id,
        d: doc.uuid,
      })
        .then((r) => {
          window.open(`${api_host}/${r}`, "_blank");
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    download(item) {
      let vm = this;
      local_api(vm, "post", "/student_document/do-download", {
        d: item.uuid,
      })
        .then((r) => {
          window.open(`${api_host}/${r}`, "_blank");
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    getData() {
      let vm = this;
      this.processing = true;

      if (vm.$props.student_in.uuid) {
        local_api(vm, "post", "/student_document/do-get-list", {
          u: vm.$props.student_in.uuid,
        })
          .then((items) => {
            vm.documents = items;
            vm.all_documents = clone(items);
            vm.processing = false;
          })
          .catch((err) => {
            error_toast(err);
            console.error(err);
          });
      } else {
        setTimeout(() => {
          this.getData();
        }, 100);
      }
    },
  },
  mounted() {
    this.getData();
  },
  watch: {},
};
</script>
